import { render, staticRenderFns } from "./ModalIzinProyek.vue?vue&type=template&id=2d1fe902&scoped=true&lang=pug&"
import script from "./ModalIzinProyek.vue?vue&type=script&lang=js&"
export * from "./ModalIzinProyek.vue?vue&type=script&lang=js&"
import style0 from "./ModalIzinProyek.vue?vue&type=style&index=0&id=2d1fe902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fe902",
  null
  
)

export default component.exports